import Cookies from 'js-cookie'
import packageJson from '../package.json'

const localhost = false
const version = '3.3.3'
const proxy = null
const clientUrl = 'https://charge.sk'
const apiUrl = 'https://api.charge.sk/api/'
const chargeTenantId = '9b671b08-c0a7-4ac9-82db-7275e7d6893c'
const mainTenantId = 'c7636d00-c0f9-4908-9699-ee67c28733c6'

export const config = localhost
    ? {
          api: '/api/',
          client: 'localhost:3000',
          version: 'dev',
          proxy: packageJson.proxy,
          chargeTenantId: '8301fe71-bc7e-49ef-b97b-a16e2744aad9',
          mainTenantId: '811eb710-9278-411d-bc7f-6af4babdbd1a',
      }
    : {
          api: apiUrl,
          version: version,
          client: clientUrl,
          proxy: proxy,
          chargeTenantId: chargeTenantId,
          mainTenantId: mainTenantId,
      }

export const getToken = () => {
    return Cookies.get('adminToken')
}

export const setToken = (token: string) => {
    Cookies.set('adminToken', token)
}

export const removeToken = () => {
    Cookies.remove('adminToken')
}
